import React, { useState } from 'react';
import { API_URL } from '../../config/config';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Link } from 'react-router-dom';
const SingUp = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [Message, setMessage] = useState(null);
	const [UserData, setUserData] = useState({
		Name: '',
		FirmName: '',
		MobileNo: '',
		Password: '',
		GSTNo: '',
		Email: '',
		UserAddress: '',
	});
	const openModal = () => {
		setIsOpen(true);
	};

	const closeModal = () => setIsOpen(false);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setUserData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};
	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (
			!UserData.Name ||
			!UserData.FirmName ||
			!UserData.MobileNo ||
			!UserData.Password ||
			!UserData.GSTNo ||
			!UserData.Email ||
			!UserData.UserAddress
		) {
			return toast.error('Please fill in all fields.');
		}

		const data = {
			Name: UserData.Name,
			FirmName: UserData.FirmName,
			MobileNo: UserData.MobileNo,
			UserPassword: UserData.Password,
			GSTNo: UserData.GSTNo,
			UserEmail: UserData.Email,
			UserAddress: UserData.UserAddress,
		};

		try {
			const response = await axios.post(`${API_URL}/User/signUp`, data);

			if (response.data.success === true) {
				toast.success(response.data.message);
				setMessage(response.data.message);
				setUserData({
					Name: '',
					FirmName: '',
					MobileNo: '',
					Password: '',
					GSTNo: '',
					Email: '',
					UserAddress: '',
				});
				openModal();
			} else if (response.data.success === false) {
				toast.error(response.data.message);
			}
		} catch (error) {
			toast.error(error.response.data.message);
		}
	};

	return (
		<>
			<div className='flex justify-center items-center md:mt-10 mt-2'>
				{/* <img src={logo} alt="Logo" /> */}
			</div>
			<div className='flex flex-col items-center justify-center'>
				<p className='uppercase md:mb-8 mb-4 text-xl md:text-2xl font-semibold'>Sign Up</p>
				<form
					className=' lg:w-1/3 md:w-1/2 w-[90%] bg-white rounded-xl shadow-xl px-6 md:px-10 py-5 '
					onSubmit={handleSubmit}>
					<div>
						<label className='text-sm md:text-base'>Name</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							type='text'
							name='Name'
							value={UserData.Name}
							onChange={handleChange}
							placeholder='Enter Your Name'
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>Firm Name</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							name='FirmName'
							type='text'
							value={UserData.FirmName}
							onChange={handleChange}
							placeholder='Enter Firm Name'
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>Mobile Number</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							name='MobileNo'
							type='text'
							value={UserData.MobileNo}
							onChange={handleChange}
							placeholder='Enter Your Mobile Number'
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>Password</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							name='Password'
							type='password'
							value={UserData.Password}
							onChange={handleChange}
							placeholder='Enter Your Password'
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>GST Number</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							name='GSTNo'
							type='text'
							value={UserData.GSTNo}
							onChange={handleChange}
							placeholder='Enter Your GST Number'
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>Email</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							type='text'
							name='Email'
							value={UserData.Email}
							onChange={handleChange}
							placeholder='Enter Your Email'
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>Address</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							type='text'
							name='UserAddress'
							value={UserData.UserAddress}
							onChange={handleChange}
							placeholder='Enter Your Address'
							required
						/>
					</div>
					<button
						type='submit'
						className='proBtn w-full h-12 mt-4 rounded bg-red-500 text-white hover:bg-red-600'>
						Submit
					</button>
					<Link to='/' className=' text-gray-600 flex justify-center items-center '>
						Already have account? <span className=' font-semibold hover:text-red-500 '> Login</span>
					</Link>
				</form>
			</div>
			{isOpen && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white p-6 rounded-md w-11/12 max-w-md'>
						<h2 className='text-xl font-semibold mb-4'>Confirmation</h2>
						<p className='mb-6 font-bold text-lg md:text-2xl'>{Message}</p>
						<div className='flex justify-between'>
							<button
								onClick={closeModal}
								className='bg-gray-100 text-yellow-500 px-4 py-2 rounded-md'>
								Ok
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default SingUp;
